import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPromptTextToVideo: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconPromptTextToVideo"><Path d="M21 21H5V15H7V19H19V7H14V5H21V21Z" fill="currentColor"/><Path d="M16 13L11 16.5V9.5L16 13Z" fill="currentColor"/><Path d="M11 6H9V5H7V10H8V12H4V10H5V5H3V6H1V3H11V6Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPromptTextToVideo;
